import { hexWithOpacity } from 'common/utils';
import { colors } from 'styles/colors';
import { fonts } from 'styles/fonts';

export const customTextFieldSlotProps = {
  input: {
    sx: {
      fontSize: '15px',
      fontFamily: fonts.neue,
      fontWeight: 500,
      color: colors.black,
    },
  },
  inputLabel: {
    sx: {
      fontSize: '15px',
      fontFamily: fonts.neue,
      fontWeight: 500,
      color: hexWithOpacity(colors.black, 0.5),

      '&.MuiInputLabel-shrink': {
        fontSize: '15px',
        fontFamily: fonts.neue,
        fontWeight: 500,
        color: colors.black,
      },

      '&.Mui-focused': {
        color: colors.black,
      },
    },
  },
  formHelperText: {
    sx: { ml: 0 },
  },
};

export const customTextFieldSx = {
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: colors.secondary,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: colors.secondary,
  },
  '& input::placeholder': {
    fontSize: '15px',
    opacity: 1,
    fontFamily: fonts.neue,
    fontWeight: 500,
    color: colors.secondary,
  },
};
